<template>
  <div class="dropdown">
    <button
      class="dropdown-toggle"
      :class="{ active: isOpen }"
      @click="toggleDropdown"
    >
      {{ selectedChatbot?.name || "Select a Bot" }}
      <img :src="require('@/assets/icons/arrow_down.svg')" alt="Dropdown Arrow" class="arrow" />
    </button>
    <div class="dropdown-menu" v-if="isOpen">
      <!-- Use v-for to dynamically render chatbot items -->
      <div
        class="dropdown-item"
        v-for="chatbot in chatbots"
        :key="chatbot.id"
        @click="selectChatbot(chatbot)">
        {{ chatbot.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chatbots: {
      type: Array,
      required: true
    },
    selectedChatbot: {
      type: Object,   // ✅ supports { id, name } and more
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      // selectedChatbot: null
    };
  },
  watch: {
    // Watch for changes in the chatbots prop and restore from localStorage
    chatbots: {
      immediate: true, // This will trigger the watcher when the component is created
      handler(newChatbots) {
        if (newChatbots && newChatbots.length > 0) {
          // Load selected chatbot from localStorage
          const storedChatbot = localStorage.getItem('selectedChatbot');
          if (storedChatbot) {
            try {
              const chatbot = JSON.parse(storedChatbot);
              // Verify the chatbot still exists in the available chatbots
              const exists = newChatbots.some(c => c.id === chatbot.id);
              if (exists) {
                this.$emit('select-chatbot', chatbot);
              }
            } catch (error) {
              console.error('Error parsing stored chatbot:', error);
            }
          }
        }
      }
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      console.log('Dropdown is now', this.isOpen);
    },
    selectChatbot(chatbot) {
      // this.selectedChatbot = chatbot;
      this.isOpen = false;

      // Save to localStorage
      localStorage.setItem('selectedChatbot', JSON.stringify(chatbot));

      this.$emit('select-chatbot', chatbot);
    }
  }
};
</script>

<style scoped>
.dropdown {
  display: inline-block;
  position: relative;
}

.dropdown-toggle {
  background-color: transparent; /* Default background color */
  color: black; /* Default text color */
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: TT Ramillas Trl, Inter, sans-serif;
  font-size: 1rem;
  margin-top: 0.625rem;
}

.dropdown-toggle.active {
  background-color: #f8f8f8; /* Background color when active */
}

.arrow {
  margin-left: 10px;
  width: 16px; /* Adjust size as needed */
  height: 16px; /* Adjust size as needed */
}

.dropdown-menu {
  /* display: block; */
  position: absolute;
  background-color: white;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  border-radius: 5px;
  overflow: hidden;
  top: 100%; /* Position below the toggle button */
  left: 0; /* Align to the left edge of the toggle button */
  font-family: TT Ramillias Initials Trl Md Medium, Inter, sans-serif;
}

.dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #ddd;
}
</style>
